
import { useState } from "react";
import { DateRange } from "@/components/DateRangeSelector";
import { usePaymentStats } from "@/hooks/usePaymentStats";
import PaymentDashboardContent from "./dashboard/PaymentDashboardContent";

interface PaymentDashboardProps {
  refreshTrigger: number;
}

const PaymentDashboard = ({ refreshTrigger }: PaymentDashboardProps) => {
  const [dateRange, setDateRange] = useState<DateRange>(() => {
    // Default to "This Month" for better data visibility
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    
    console.log("PaymentDashboard: Initial date range:", {
      from: firstDayOfMonth,
      to: lastDayOfMonth
    });
    
    return { 
      from: firstDayOfMonth, 
      to: lastDayOfMonth 
    };
  });

  const { stats, loading } = usePaymentStats(refreshTrigger, dateRange);

  const handleDateRangeChange = (newRange: DateRange) => {
    console.log("PaymentDashboard: Date range changed:", newRange);
    setDateRange(newRange);
  };

  return (
    <div className="space-y-2">
      <PaymentDashboardContent 
        stats={stats}
        loading={loading}
        onDateRangeChange={handleDateRangeChange}
        currentDateRange={dateRange}
      />
    </div>
  );
};

export default PaymentDashboard;
